import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BestOddsComponent } from './best-odds/best-odds.component';

const routes: Routes = [
  {path: "", component: BestOddsComponent},
  {
    path: '',
    redirectTo: '',
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class BestOddsRoutingModule { }
